export default __webpack_public_path__ + "static/bannerPubli-EC-6e6688138be7e3adf0223e1cf5db7a9e.png";